import React from 'react';
import { NavLink } from 'react-router-dom'
import { Component } from 'react';
import { useAuthContext } from "../../hooks/useAuthContext";
import {
  DashboardIcon,
  ApplicationsIcon,
  InfluencersIcon,
  BrandsIcon,
  UsersIcon,
  ReferralsIcon,
  SettingsIcon,
  CloseIcon,
  ListIcon
} from './NavIcons';

import './AdminNav.css';

class AdminNav extends Component {
  state = { show: false }
  toggle = () => this.setState((currentState) => ({show: !currentState.show}));

  render() {
    return (
      <div className="leftSideMenuShift col-xxl-2 pt-0 pb-0 pt-xl-4 pb-xl-4 border-end bg-background">

        <div className="leftSideMenu pb-xl-4 px-md-3">
          {this.props.currentProfile.type == "admins" && 
            <NavLink to="/Administration/Dashboard" activeclassname="active">
              <span className="me-1 fill stroke">
                <DashboardIcon />
              </span> Dashboard
            </NavLink>
          }
          {this.props.currentProfile.type == "admins" && 
            <NavLink to="/Administration/Applications" activeclassname="active">
              <span className="me-1 fill stroke">
                <ApplicationsIcon />
              </span> Applications
            </NavLink>
          }
          {(this.props.currentProfile.type == "admins" || this.props.views.includes("influencersMultiple")) && 
            <NavLink to="/Administration/Influencers" activeclassname="active">
              <span className="me-1 fill">
                <InfluencersIcon />
              </span> Members
            </NavLink>
          }
          {(this.props.currentProfile.type == "admins" || this.props.views.includes("brandsMultiple")) && 
            <NavLink to="/Administration/Brands" activeclassname="active">
              <span className="me-1 fill">
                <BrandsIcon />
              </span> Brands
            </NavLink>
          }
          {this.props.currentProfile.type == "admins" && 
            <NavLink to="/Administration/Users" activeclassname="active">
              <span className="me-1 fill stroke">
                <UsersIcon />
              </span> Users
            </NavLink>
          }
          {this.props.currentProfile.type == "admins" && 
            <NavLink to="/Administration/Referrals" activeclassname="active">
              <span className="me-1 fill">                   
                <ReferralsIcon />
              </span> Referrals
            </NavLink>
          }
          {this.props.currentProfile.type == "admins" && 
            <NavLink to="/Administration/Settings" activeclassname="active">
              <span className="me-1 fill">
                <SettingsIcon />
              </span> Settings
            </NavLink>
          }
        </div>

        <button onClick={this.toggle} className="adminFooterBtn">
          {this.state.show ? 
            <CloseIcon /> :
            <ListIcon />
          }
        </button>

        {this.state.show && 
          <div className="adminFooter">
          {this.props.currentProfile.type == "admins" && 
              <NavLink to="/Administration/Dashboard" activeclassname="active">
                <span className="fill stroke">
                  <DashboardIcon />
                </span>
                <span className='adminNavName'>Dashboard</span>
              </NavLink>
            }
            {this.props.currentProfile.type == "admins" && 
              <NavLink to="/Administration/Applications" activeclassname="active">
                <span className="fill stroke">
                  <ApplicationsIcon />
                </span>
                <span className='adminNavName'>Applications</span>
              </NavLink>
            }
            {(this.props.currentProfile.type == "admins" || this.props.views.includes("influencersMultiple")) && 
              <NavLink to="/Administration/Influencers" activeclassname="active">
                <span className="fill">
                  <InfluencersIcon />
                </span>
                <span className='adminNavName'>Members</span>
              </NavLink>
            }
            {(this.props.currentProfile.type == "admins" || this.props.views.includes("brandsMultiple")) && 
              <NavLink to="/Administration/Brands" activeclassname="active">
                <span className="fill">
                  <BrandsIcon />
                </span>
                <span className='adminNavName'>Brands</span>
              </NavLink>
            }
            {this.props.currentProfile.type == "admins" && 
              <NavLink to="/Administration/Users" activeclassname="active">
                <span className="fill stroke">
                  <UsersIcon />
                </span>
                <span className='adminNavName'>Users</span>
              </NavLink>
            }
            {this.props.currentProfile.type == "admins" && 
              <NavLink to="/Administration/Referrals" activeclassname="active">
                <span className="fill">           
                  <ReferralsIcon />
                </span>
                <span className='adminNavName'>Referrals</span>
              </NavLink>
            }
            {this.props.currentProfile.type == "admins" && 
              <NavLink to="/Administration/Settings" activeclassname="active">
                <span className="fill">
                  <SettingsIcon />
                </span>
                <span className='adminNavName'>Settings</span>
              </NavLink>
            }
          </div>
        }

      </div>
    )
  }
}

export default function (props) {
    const { views, currentProfile } = useAuthContext();
    return <AdminNav views={views} currentProfile={currentProfile} />;
  }
